import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { useQueryParams } from "src/hooks/useQueryParams";
import { blogTrns } from "src/page-components/blog/trns";
import { Search } from "src/page-components/blog/Search";
import { QueryParamKeys } from "src/page-components/blog/types";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";

export const Header: FC = () => {
  const { t } = useTranslation();

  const isMDScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.MD,
  });

  const { getQueryParam, setQueryParam } = useQueryParams();

  const search = getQueryParam(QueryParamKeys.SEARCH) || "";
  const category = getQueryParam(QueryParamKeys.CATEGORY) || "";

  const getTitle = () => {
    if (category) {
      return isMDScreenBreakpoint
        ? category
        : `${t(blogTrns.title)} - ${category}`;
    }

    return t(blogTrns.title);
  };

  const title = getTitle();

  const onChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQueryParam(QueryParamKeys.SEARCH, e.target.value);
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-5 sm:gap-10">
      <h1 className="text-purple-base text-28 font-semibold line-clamp-1">
        {title}
      </h1>

      <Search value={search} onChange={onChangeSearch} />
    </div>
  );
};
